<template>
    <div class="sidebar-info" v-if="companyInfo">
       <el-form  size="mini" label-width="120px" class="menu-top-form">
          <el-row>
              <el-col :span="6">
                   <div class="avatar-wrapper">
                    <img v-if="imageUrl" :src="imageUrl" class="logo-avatar">
                </div>
              </el-col>
              <el-col :span="18">
                  <el-popover
                      placement="bottom"
                      :title="title"
                      :width="350"
                      trigger="hover">
                      <el-form :model="companyInfo" size="mini" label-width="120px" class="company-form">
                          <el-form-item label="企业名称" prop="companyName">
                              <el-tooltip class="item" effect="light" :content="companyInfo.companyName" placement="bottom">
                                <el-input v-model="companyInfo.companyName" :disabled=true></el-input>
                              </el-tooltip>
                            </el-form-item>
                          <el-form-item label="企业简称" prop="companyShortName">
                              <el-input v-model="companyInfo.companyShortName" :disabled=true></el-input>
                          </el-form-item>
                          <el-form-item label="已使用空间" prop="percentage">
                              {{usedFileByteSize}}
                              <el-progress :text-inside="true" :stroke-width="18" :percentage="companyInfo.usedFilePercent"></el-progress>
                          </el-form-item>
                            <el-row>
                                  <el-col :span="8">
                                      <el-tooltip class="item" effect="light" content="可用人数上限" placement="bottom-start">
                                      <el-button>可用人数{{companyInfo.companyResource.buyPersonNum}}人</el-button>
                                      </el-tooltip>
                                  </el-col>
                                  <el-col :span="8">
                                      <el-tooltip class="item" effect="light" content="审批流定义上限" placement="bottom">
                                      <el-button>流程定义数{{companyInfo.companyResource.approvalTemplateNum}}个</el-button>
                                      </el-tooltip>
                                  </el-col>
                                  <el-col :span="8">
                                      <el-tooltip class="item" effect="light" content="应用报表上限" placement="bottom-end">
                                      <el-button>应用报表数{{companyInfo.companyResource.applicationReportNum}}个</el-button>
                                      </el-tooltip>
                                  </el-col>
                              </el-row>
                      </el-form>
                      <el-button class="company-btn" type="primary" plain slot="reference"><font size="3" >{{companyInfo.companyShortName}}</font></el-button>
                  </el-popover>
              </el-col>
          </el-row>
        </el-form>
    </div>
</template>

<script>
    import { API_IMG_DOWNLOAD } from '@/common/constants';
    export default {
        data () {
            return {
                imageUrl: ''
            };
        },
        props: {
            title: {
                type: String
            },
            companyInfo: {
                type: Object
            }
        },
        watch: {
            'companyInfo.companyLogo' (newVal, oldVal) {
                this.setCompanyLogo();
            },
            'companyInfo.companyName' (newVal, oldVal) {
                this.companyInfo.companyName = newVal;
            },
            'companyInfo.companyShortName' (newVal, oldVal) {
                this.companyInfo.companyShortName = newVal;
            }
        },
        computed: {
            storageSize () {
                return this.bytesToSize(this.companyInfo.companyResource.storageSize);
            },
            usedFileByteSize () {
                return this.bytesToSize(this.companyInfo.usedFileByteSize);
            }
        },
        created () {
            this.setCompanyLogo();
        },
        methods: {
            bytesToSize (bytes) {
                if (bytes === 0) return '0 B';
                let k = 1024;
                // let sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                let sizes = ['B', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
                let i = Math.floor(Math.log(bytes) / Math.log(k));
                let num = bytes / Math.pow(k, i);
                return num.toPrecision(3) + ' ' + sizes[i];
            },
            setCompanyLogo () {
                let prefix = '';
                let logoUrl = '';
                let env = process.env.NODE_ENV;
                if (env === 'production') {
                    prefix = '/bcbpm';
                }
                if (this.companyInfo.companyLogo) {
                    logoUrl = `${API_IMG_DOWNLOAD}${this.companyInfo.companyLogo}`;
                } else {
                    logoUrl = prefix + '/images/default.png';
                }
                this.imageUrl = logoUrl;
            }

        }
    };
</script>

<style lang="less">
    .sidebar-info {
        background: #ecf5ff;
        // margin-left: 8px;
        // padding: 9px 0;
        // padding: 5px 5px 0px 2px;
        border-bottom: 1px solid #eee;
        border-right: 1px solid #eee;
        .company-btn {
            // margin-left: 8px;
            margin-top: 14px;
            width: 160px;
        }

        .avatar-wrapper {
          cursor: pointer;
          margin-top: -4px;
          // margin-left: 1px;
          position: relative;
          .logo-avatar {
              width: 50px;
              height: 50px;
              border-radius: 10px;
          }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarFreeInfo.vue